<template>
  <div class="verifying-wrapper">
    <el-card shadow="hover" class="verifying-card">
      <div v-if="status === 'loading'" class="verifying-content">
        <i class="el-icon-loading" style="font-size: 36px; margin-bottom: 16px"></i>
        <h3>Verifying your account…</h3>
        <p>Please wait while we securely check your details.</p>
      </div>
      <div v-else-if="status === 'error'" class="verifying-content">
        <h3>Verification failed</h3>
        <p style="color: #d9534f">{{ errorMessage }}</p>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'VerifyingScreen',
    computed: {
      ...mapGetters('auth', ['getAuthenticationStatus', 'getEmailExist']),
      ...mapGetters('applicationUsers', ['getUserVerifyDetails']),
      ...mapGetters('company', ['getContactLoginSlug', 'getSingleCompanyLogo']),
    },
    data() {
      return {
        status: 'loading',
        errorMessage: '',
      };
    },
    mounted() {
      this.verifyUser();
    },
    methods: {
      async verifyUser() {
        this.status = 'loading';
        try {
          let user_type = 'system';
          const params = this.$route.query;
          const required = ['company', 'email', 'target_url', 'type'];
          const missing = required.filter((k) => !params[k]);
          if (missing.length) {
            throw new Error(`these required fields ${missing} are missing`);
          } else {
            const input = { slug: this.$route.query.company };
            await this.$store.dispatch('company/fetchCompanyBySlug', input);
            await Promise.all([
              this.$store.dispatch('applicationUsers/fetchUserVerifyDetails', {
                company_id: this.getContactLoginSlug._id,
                email: this.$route.query.email,
                externalSource: true,
              }),
              this.$store.dispatch('auth/checkUserExist', this.$route.query.email),
            ]);
            if (this.$route.query.type === 'commom') {
              if (this.getEmailExist) {
                await this.systemUserLogin();
              } else if (
                this.getUserVerifyDetails &&
                this.getUserVerifyDetails.status &&
                this.getUserVerifyDetails.statusCode === 'login_verified'
              ) {
                user_type = 'application';
                await this.loginApplicationUser();
              } else {
                throw Error('User Not Found');
              }
            } else if (this.$route.query.type === 'system') {
              if (this.getEmailExist) {
                await this.systemUserLogin();
              } else {
                throw Error('User Not Found');
              }
            } else {
              if (
                this.getUserVerifyDetails &&
                this.getUserVerifyDetails.status &&
                this.getUserVerifyDetails.statusCode === 'login_verified'
              ) {
                user_type = 'application';
                await this.loginApplicationUser();
              } else {
                throw Error(this.getUserVerifyDetails.message);
              }
            }
            var pB64 = this.$CryptoJS.AES.encrypt(
              JSON.stringify({
                path: params['target_url'],
              }),
              'esignsRedirect'
            ).toString();
            var pE64 = this.$CryptoJS.enc.Base64.parse(pB64);
            var pHex = pE64.toString(this.$CryptoJS.enc.Hex);
            this.$router.push({
              name: user_type === 'application' ? 'ap-Welcome' : 'Welcome',
              query: { redirect_url: pHex },
            });
          }
        } catch (err) {
          this.status = 'error';
          this.errorMessage = err.message || 'Something went wrong.';
        }
      },
      async loginApplicationUser() {
        await this.$store.dispatch('applicationUsers/fetchSetUserSignInVerify', {
          contact_id: this.getUserVerifyDetails?.data._id,
          externalSource: true,
        });
      },
      async systemUserLogin() {
        let params = {
          email: this.$route.query.email,
          externalSource: true,
        };
        await this.$store.dispatch('auth/signin', params);
      },
    },
  };
</script>

<style scoped>
  .verifying-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: #f5f7fa;
  }

  .verifying-card {
    padding: 40px;
    text-align: center;
    border-radius: 16px;
    min-width: 320px;
  }

  .spinner {
    font-size: 36px;
    color: #409eff;
    animation: spin 1.2s linear infinite;
    margin-bottom: 16px;
  }

  .error-icon {
    font-size: 36px;
    margin-bottom: 16px;
  }
</style>
